module.exports = __webpack_public_path__ + "img/smartphone.3db91096.png";